import { render, staticRenderFns } from "./SpecialOfferDetail.vue?vue&type=template&id=68f74455"
import script from "./SpecialOfferDetail.vue?vue&type=script&lang=js"
export * from "./SpecialOfferDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports